import { render } from "./Profile.vue?vue&type=template&id=12429242&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=12429242&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12429242"

export default script